import { updateSpesificUserData } from "../../../store/Slices/UserSlice";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import LoadingSkeletonImageDynamic from "../../../components/LoadingSkeletonImageDynamic";
import { useFile } from "../../../context/FileProvider";
import { useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { IoImagesOutline } from "react-icons/io5";
import TextTranslate from "../../../utils/TextTranslate";

export default function SelectImageFromGallery() {
  const { setSelectedFile } = useFile();
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state.userData);

  const onFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files?.[0];
    setSelectedFile(null);
    if (!files) return;
    setSelectedFile(files);
    setSelectedFileUrl(URL.createObjectURL(files));
    dispatch(updateSpesificUserData({ avatar_path: "" }));
  };

  const photoSelected = userData.avatar_path == "" && !!selectedFileUrl;

  return (
    <div className="overflow-hidden rounded-2xl bg-secondary p-4 shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      <div className="mb-3 text-[13px] font-medium uppercase tracking-wide text-lightText">
        <TextTranslate text="Choose From" />
      </div>
      <div className="flex flex-col items-center gap-2 py-2">
        <div
          className={`relative grid place-content-center rounded-full ${
            photoSelected
              ? "ring-2 ring-themeColor ring-offset-2 ring-offset-secondary"
              : ""
          }`}
        >
          {selectedFileUrl ? (
            <LoadingSkeletonImageDynamic
              radius=""
              className="h-24 w-24 rounded-full object-cover"
              image_height=""
              image_url={selectedFileUrl || userData.profile_pic}
              image_width=""
            />
          ) : (
            <label
              htmlFor="selectProfileImage"
              className="grid h-24 w-24 cursor-pointer place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            >
              <IoImagesOutline className="text-3xl text-themeColor" />
            </label>
          )}
          <input
            onChange={onFileChange}
            accept="image/*"
            className="hidden"
            type="file"
            id="selectProfileImage"
          />
          {photoSelected && (
            <label
              htmlFor="selectProfileImage"
              className="absolute bottom-0 right-0 z-30 grid h-8 w-8 cursor-pointer place-content-center rounded-full bg-themeColor text-themeTextColor shadow-sm"
            >
              <BiEditAlt className="text-lg" />
            </label>
          )}
        </div>
        <div className="text-[15px] font-medium text-darkText">
          <TextTranslate text="Your Photos" />
        </div>
      </div>
    </div>
  );
}
